export const translations = {
  sv: {
    componentheading: 'Våra priser och villkor för inrikesförsändelser för dig som direktbetalande kund?',
    deliveryscopeheading: 'Endast leveranser inom Sverige',
    resultlistheading: 'Några bra alternativ för dig',
    sizeheading: 'Uppskatta storleken på din försändelse',
    weightheading: 'Uppskatta vikten på din försändelse',
    weightlabel: 'Vikt',
    maxweightlabel: 'Maxvikt',
    maxmeasurementlabel: 'Maxvolym',
    senddirectcta: 'Köp online',
    stampshopcta: 'Till butiken',
    message: '*Vid köp hos valfritt ombud',
    servicePointHeader: 'Eller hitta närmaste serviceställe',
    servicePointLink: 'Hitta Serviceställe',
    realPostcard: 'Köp Riktiga Vykort',
    realPostcardMobile: 'Ladda ner appen',
    ombudHeader: 'Köp via ombud',
    from: 'Från ',
    labelMaxDimensionsRoll: 'Rulle',
    labelMaxDimensions: 'Maxmått',
    noResultMessage: 'Inga produkter matchar dina kriterier',
    clearFilterButton: 'Rensa alla filter',
    compensateUpTo: 'Ersättning upp till',
    countryToSendTo: 'Vilket land vill du skicka till?',
    smallPackage: 'Litet paket',
    mediumPackage: 'Medium paket',
    largePackage: 'Stort paket',
    personComparison: 'Person för jämförelse',
    cloudsImage: 'Bild på moln',
  },
  en: {
    componentheading: 'Our prices and terms and conditions for domestic shipments for you as a direct paying customer',
    deliveryscopeheading: 'Deliveries within Sweden only',
    resultlistheading: 'Some suitable options for you',
    sizeheading: 'Estimate the size of your shipment',
    weightheading: 'Estimate the weight of your shipment',
    weightlabel: 'Weight',
    maxweightlabel: 'Max weight',
    maxmeasurementlabel: 'Maximum measurement',
    senddirectcta: 'Buy Online',
    stampshopcta: 'To the Store',
    message: 'When buying from any agent',
    servicePointHeader: 'Find service point',
    servicePointLink: 'Find service point',
    realPostcard: 'Buy Postcards',
    realPostcardMobile: 'Download the app',
    ombudHeader: 'Purchase by agent',
    from: 'From ',
    labelMaxDimensionsRoll: 'Roll',
    labelMaxDimensions: 'Maximum dimensions',
    noResultMessage: 'No products match your criterias',
    clearFilterButton: 'Clear all filters',
    compensateUpTo: 'Compensated up to',
    countryToSendTo: 'To which country do you want to send?',
    smallPackage: 'Small package',
    mediumPackage: 'Medium package',
    largePackage: 'Large package',
    personComparison: 'Person for comparison',
    cloudsImage: 'Image of clouds',
  },
  da: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveringer indenfor Sverige',
    resultlistheading: 'Dine muligheder',
    sizeheading: 'Hvor stor er din forsendelse?',
    weightheading: 'Hvor meget vejer din forsendelse?',
    weightlabel: 'Vægt',
    maxweightlabel: 'Max vægt',
    maxmeasurementlabel: 'Maks. Volumen',
    senddirectcta: 'Køb Online',
    stampshopcta: 'Til butikken',
    message: 'When buying from any agent',
    servicePointHeader: 'Find nærmeste servicested',
    servicePointLink: 'Find nærmeste servicested',
    realPostcard: 'Køb Riktiga Vykort',
    ombudHeader: 'Køb af agent',
    from: 'Fra ',
    labelMaxDimensionsRoll: 'Rulle',
    labelMaxDimensions: 'Maks. mål og vægt',
    noResultMessage: 'Ingen produkter matcher dine kriterier',
    clearFilterButton: 'Ryd alle filtre',
    compensateUpTo: 'Erstatning op til',
    countryToSendTo: 'Hvilket land vil du sende til?',
    smallPackage: 'Lille pakke',
    mediumPackage: 'Mellem pakke',
    largePackage: 'Stor pakke',
    personComparison: 'Person til sammenligning',
    cloudsImage: 'Billede af skyer',
  },
  no: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveranser innen Sverige',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vekt',
    maxweightlabel: 'Maks vekt',
    maxmeasurementlabel: 'Maks volum',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
    noResultMessage: 'No products match your criterias',
    clearFilterButton: 'Clear all filters',
    compensateUpTo: 'Kompensert inntil',
    countryToSendTo: 'Hvilket land vil du sende til?',
  },
  fi: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Toimitukset vain Ruotsin sisällä',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Paino',
    maxweightlabel: 'Max paino',
    maxmeasurementlabel: 'Max äänenvoimakkuus',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
    noResultMessage: 'No products match your criterias',
    clearFilterButton: 'Clear all filters',
    compensateUpTo: 'Korvaus asti',
    countryToSendTo: 'Mihin maahan haluaisit lähettää?',
  },
};

export const markets = {
  se: {
    currency: 'kr',
    country: 'Sweden',
    servicePoint: 'https://www.postnord.se/vara-verktyg/sok-brevlada-eller-servicestalle',
  },
  dk: {
    currency: 'dk',
    country: 'Denmark',
    servicePoint: 'https://www.postnord.dk/varktojer/find-os',
  },
  fi: {
    currency: ' €',
    country: 'Finland',
    servicePoint: '',
  },
  no: {
    currency: 'kr',
    country: 'Norway',
    servicePoint: '',
  },
};
